<template>
  <div>
    <!-- 修改待普/精检数  修改待布标处理数 包裹拆分 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="editDialog" center width="1424px">
      <div class="tableBox">
        <div class="mytable">
          <div class="tul ttt">
            <div class="tli ttt NO">NO</div>
            <!-- 选择 -->
            <div class="tli ttt choose">{{ $t("message.choose") }}</div>
            <!-- 店铺信息 -->
            <div class="tli ttt storeInformation">
              {{ $t("message.storeInformation") }}
            </div>
            <!-- 照片 -->
            <div class="tli ttt">{{ $t("message.photo") }}</div>
            <!-- 业务编辑商品属性 -->
            <div class="tli ttt theBusinessEditsTheCommodityProperties listTd">
              {{ $t("message.theBusinessEditsTheCommodityProperties") }}
            </div>
            <!-- 待普/精检数 -->
            <div class="tli ttt">
              {{ $t("message.pendingPrecisionTestNumber") }}
            </div>
            <!-- 单价(元) -->
            <div class="tli ttt">{{ $t("message.priceYuan") }}</div>
            <!-- 物流号 -->
            <div class="tli ttt listTd logisticsNumber">
              {{ $t("message.logisticsNumber") }}
            </div>
            <!-- 新检品单数量 -->
            <div class="tli ttt tInput" v-if="editType == 'generalOrPrecisionExamination'">
              {{ $t("message.numberOfNewInspectionOrders") }}
            </div>
            <!-- 修改后待布标处理数 -->
            <div class="tli ttt tInput" v-else-if="editType == 'clothLabelTreatment'">
              {{ $t("message.numberOfLabelsToBeLaidAfterModification") }}
            </div>
            <template v-if="editType == 'breakUp'">
              <!-- 应检品数 -->
              <div class="tli ttt">
                {{ $t("message.numberOfProductsToBeInspected") }}
              </div>
              <!-- 剩余应检品数 -->
              <div class="tli ttt">
                {{ $t("message.numberOfRemainingProductsToBeInspected") }}
              </div>
              <!-- 新检品单数量 -->
              <div class="tli ttt tInput">
                {{ $t("message.numberOfNewInspectionOrders") }}
              </div>
            </template>
          </div>
          <div class="tcon" v-for="(orderItem, orderIndex) in tableData" :key="'order' + orderIndex">
            <div class="tul tconHead">
              <div class="tconHeadOpt flexDirColumn">
                <div>
                  <!-- 客户付款时间 -->
                  <p>{{ $t("message.customerPaymentTime") }}：</p>
                  <p>{{ orderItem.order_time_node.datetime_pay_confirm }}</p>
                </div>
              </div>
              <div class="tconHeadOpt flexDirColumn">
                <div>
                  <p>
                    <span class="yellowFont">{{ orderItem.order_sn }}</span>
                  </p>
                  <p>{{ orderItem.user.realname }}</p>
                </div>
              </div>
              <div class="tconHeadOpt">
                <!-- 交易号 -->
                {{ $t("message.transactionNumber") }}
                <span class="yellowFont">{{ orderItem.purchase_no }}</span>
              </div>
              <div class="tconHeadOpt">
                <!-- 业务 -->
                {{ $t("message.business") }}：
                {{ orderItem.y_admin.realname }}
              </div>
              <div class="tconHeadOpt">
                <!-- 采购 -->
                {{ $t("message.purchase") }}：
                {{ orderItem.g_admin.realname }}
              </div>
              <div class="tconHeadOpt">
                <!-- 配货 -->
                {{ $t("message.distribution") }}：
                {{ orderItem.p_admin.realname }}
              </div>
            </div>
            <div class="tul tbo" v-for="(goodsItem, goodsIndex) in orderItem.inspect_detail" :key="'goods' + goodsIndex">
              <div class="tli tbo NO">{{ goodsItem.sorting }}</div>
              <!-- 选择 -->
              <div class="tli tbo choose">
                <el-checkbox v-model="goodsItem.checked"></el-checkbox>
              </div>
              <!-- 店铺信息 -->
              <div class="tli tbo storeInformation">
                <p>
                  {{ goodsItem.order_purchase.order_detail.shop_name }}
                </p>
                <p>
                  {{ goodsItem.order_purchase.order_detail.from_platform }}
                </p>
                <p>{{ goodsItem.order_purchase.order_detail.shop_id }}</p>
              </div>
              <!-- 照片 -->
              <div class="tli tbo">
                <uploadFile :imgList="goodsItem.order_purchase.order_detail.pic" :showDel="false" target="hover">
                </uploadFile>
              </div>
              <!-- 业务编辑商品属性 -->
              <div class="tli tbo theBusinessEditsTheCommodityProperties listTd">
                <div>
                  <p v-for="(goodsDetailItem, goodsDetailIndex) in goodsItem
                    .order_purchase.order_detail.detail_y" :key="'goodsDetail' + goodsDetailIndex">
                    {{ goodsDetailItem.key }}： {{ goodsDetailItem.value }}
                  </p>
                </div>
              </div>

              <!-- 待普/精检数 -->
              <div class="tli tbo">
                {{ goodsItem.inspect_num }}
              </div>
              <!-- 单价(元) -->
              <div class="tli tbo">
                {{ goodsItem.order_purchase.order_detail.confirm_price }}
              </div>
              <!-- 物流号 -->
              <div class="tli tbo listTd logisticsNumber">
                <div>
                  <p v-for="express in goodsItem.order_purchase
                    .order_purchase_express" :key="express.id">
                    {{ express.express_no }}
                  </p>
                </div>
              </div>
              <!-- 新检品单数量 -->
              <div class="tli tbo tInput" v-if="editType == 'generalOrPrecisionExamination'">
                <el-input v-model="goodsItem.num"></el-input>
              </div>
              <!-- 修改后待布标处理数 -->
              <div class="tli tbo tInput" v-else-if="editType == 'clothLabelTreatment'">
                <el-input v-model="goodsItem.label_should_num"></el-input>
              </div>
              <template v-if="editType == 'breakUp'">
                <!-- 应检品数 -->
                <div class="tli tbo">
                  {{ goodsItem.num }}
                </div>
                <!-- 剩余应检品数 -->
                <div class="tli tbo">
                  {{ goodsItem.inspect_num }}
                </div>
                <!-- 新检品单数量 -->
                <div class="tli tbo tInput">
                  <el-input v-model="goodsItem.num"></el-input>
                </div>
              </template>
            </div>
          </div>
          <!-- 数据为空 -->
          <div class="tul tNullData" v-if="tableData.length == 0">
            {{ $t("message.dataIsNull") }}
          </div>
        </div>
      </div>
      <div class="footer">
        <!-- 检品员选择 -->
        <el-select :placeholder="$t('message.testArticlePersonSelect')" v-if="editType == 'breakUp'" v-model="j_id"
          filterable>
          <el-option v-for="item in J" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
        <!-- 确认修改 -->
        <el-button type="primary" @click="updateNum" v-if="editType == 'generalOrPrecisionExamination'">{{
          $t("message.confirmTheModification") }}</el-button>
        <el-button type="primary" @click="updateLabelShouldNum" v-else-if="editType == 'clothLabelTreatment'">{{
          $t("message.confirmTheModification") }}</el-button>
        <el-button type="primary" @click="inspectSplit" v-if="editType == 'breakUp'">{{
          $t("message.confirmTheModification") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadFile from "../../../../components/uploadFile/uploadFile.vue";
export default {
  data() {
    return {
      editDialog: false,
      editType: "generalOrPrecisionExamination",
      tableData: [], //表格数据
      goodsList: [], //商品数据
      title: "",
      j_id: "",
    };
  },
  components: {
    uploadFile,
  },
  computed: {
    J() {
      return this.$store.state.authWorkGroupAdmin.j;
    },
  },
  mounted() { },
  methods: {
    open(type) {
      this.editType = type; //修改待普/精检数  修改待布标处理数 包裹拆分
      this.editDialog = true;
      //   将父组件数据深拷贝并删除未选中数据
      let tableData = JSON.parse(JSON.stringify(this.$parent.tableData));
      this.tableData = [];
      this.goodsList = [];

      tableData.forEach(item => {
        let orderItem = null
        let flag = item.inspect_detail.some(items => items.checked)

        if (flag) {
          orderItem = JSON.parse(JSON.stringify(item))
          orderItem.inspect_detail = []
        }
        item.inspect_detail.forEach(items => {
          if (items.checked) {
            orderItem.inspect_detail.push(items)
            this.goodsList.push(items)
          }
        })

        if (orderItem != null) {

          this.tableData.push(orderItem)
        }

      })

      // for (let i = 0; i < this.tableData.length; i++) {
      //   const orderItem = this.tableData[i];
      //   for (let j = 0; j < orderItem.inspect_detail.length; j++) {
      //     const goodsItem = orderItem.inspect_detail[j];
      //     if (!goodsItem.checked) {
      //       orderItem.inspect_detail.splice(j, 1);
      //       j--;
      //     } else {
      //       goodsItem.checked = false;
      //       this.goodsList.push(goodsItem);
      //     }
      //   }
      //   // 如果所有商品都未选中就删除订单数据
      //   if (!orderItem.inspect_detail.length) {
      //     this.tableData.splice(i, 1);
      //   }
      // }

      if (type == "generalOrPrecisionExamination") {
        this.title = this.$t("message.subjectToRevisionOfPrecisionCheckNumber");
      } else if (type == "clothLabelTreatment") {
        this.title = this.$t("message.theNumberOfLabelsToBeDeployedIsChanged");
      } else {
        this.title = this.$t("message.packageSplit");
      }
    },
    // 确认修改
    confirmTheModification() {
      let editData = [];
      this.goodsList.forEach((goodsItem) => {
        if (goodsItem.checked) {
          editData.push(goodsItem);
        }
      });
      // 未选择操作数据
      if (!editData.length)
        return this.$message.warning(
          this.$t("message.operationDataIsNotSelected")
        );
      // 是否确认修改?
      this.$confirm(
        this.$t("message.doYouWantToConfirmTheModification"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          //   根据类别判断调用接口
          let apiName = {
            generalOrPrecisionExamination: "updateNum",
            clothLabelTreatment: "updateLabelShouldNum",
            breakUp: "inspectSplit",
          }[this.editType];
          this.$api.inspectionApi[apiName]({ list: editData }).then((res) => {
            this.editDialog = false;
            this.$parent.getData();
          });
        })
        .catch(() => { });
    },
    // 修改待普/精检数
    updateNum() {
      let editData = [];
      this.goodsList.forEach((goodsItem) => {
        if (goodsItem.checked) {
          editData.push(goodsItem);
        }
      });
      // 未选择操作数据
      if (!editData.length)
        return this.$message.warning(
          this.$t("message.operationDataIsNotSelected")
        );
      // 是否确认修改?
      this.$confirm(
        this.$t("message.doYouWantToConfirmTheModification"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {

          this.$api.inspectionApi.updateNum({ list: editData }).then((res) => {
            this.editDialog = false;
            this.$parent.getData();
            this.$parent.checked = false;
          });
        })
        .catch(() => { });
      //    //   根据类别判断调用接口
      //   let apiName = {
      //     generalOrPrecisionExamination: "updateNum",
      //     clothLabelTreatment: "updateLabelShouldNum",
      //     breakUp: "inspectSplit",
      //   }[this.editType];
    },
    // 修改待布标处理数
    updateLabelShouldNum() {
      let editData = [];
      this.goodsList.forEach((goodsItem) => {
        if (goodsItem.checked) {
          editData.push(goodsItem);
        }
      });
      // 未选择操作数据
      if (!editData.length)
        return this.$message.warning(
          this.$t("message.operationDataIsNotSelected")
        );
      // 是否确认修改?
      this.$confirm(
        this.$t("message.doYouWantToConfirmTheModification"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.inspectionApi
            .updateLabelShouldNum({ list: editData })
            .then((res) => {
              this.editDialog = false;
              this.$parent.getData();
              this.$parent.checked = false;
            });
        })
        .catch(() => { });
    },
    // 包裹拆分
    inspectSplit() {
      let datas = {
        data: [],
        j_id: this.j_id,
      };
      this.goodsList.forEach((goodsItem) => {
        if (goodsItem.checked) {
          datas.data.push({
            id: goodsItem.id,
            num: goodsItem.num,
          });
        }
      });
      // 未选择操作数据
      if (!datas.data.length)
        return this.$message.warning(
          this.$t("message.operationDataIsNotSelected")
        );
      if (this.j_id == "") return this.$message.warning("未选择检品员");
      // 是否确认修改?
      this.$confirm(
        this.$t("message.doYouWantToConfirmTheModification"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.inspectionApi.inspectSplit(datas).then((res) => {
            this.editDialog = false;
            this.$parent.getData();
            this.$parent.checked = false;
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.tableBox {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 24px;

  .mytable {
    .tul {
      display: flex;
      align-items: center;

      // 表头
      &.ttt {
        background: #edeff4;
        border-radius: 4px 4px 0px 0px;
      }

      //单条数据二级头部
      &.tconHead {
        height: 60px;
        background: #545467;
        border-radius: 4px;
        color: white;
        margin-top: 20px;
        padding: 0 24px;

        .tconHeadOpt {
          margin-right: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      //单条数据二级数据
      &.tbo {
        border-bottom: solid 1px #edeff4;

        &:hover {
          background-color: #eee;
        }
      }

      &.tfoot {
        min-height: 60px;
        display: flex;
        align-items: center;
        padding: 10px;

        .el-button {
          margin-right: 15px;
        }
      }

      // 单个单元格
      .tli {
        box-sizing: border-box;
        flex: 1;
        text-align: center;
        margin: 0 6px;

        &.ttt {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }

        &.tbo {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 132px;
          overflow: auto;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        // 列表单元格信息
        &.listTd {
          flex: 0 0 110px;

          &.tbo {
            flex-direction: column;
            align-items: flex-start;

            >div {
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;

              p {
                width: 100%;
                text-align: left;
              }
            }

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-flex;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            // height: unset;
            // flex-wrap: wrap;
            // height: 112px;
          }
        }

        // 备注单元格信息
        &.remarkTd {
          flex: 0 0 120px;

          &.tbo {
            height: 112px;
            // 和其他页面统一所以不加
            // border: 1px solid #dcdfe6;
            border-radius: 4px;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            padding: 13px 9px;
          }
        }

        //   输入框单元格
        &.tInput {
          &.tbo {

            input,
            /deep/input {
              text-align: center;
            }
          }
        }

        // 店铺信息
        &.storeInformation {
          flex: 0 0 120px;

          &.tbo {
            flex-direction: column;
            text-align: center;
          }
        }

        // 业务编辑商品属性
        &.theBusinessEditsTheCommodityProperties {
          flex: 0 0 120px;
        }

        &.NO {
          flex: 0 0 80px;
        }

        &.choose {
          flex: 0 0 80px;
        }

        // 物流号
        &.logisticsNumber {
          justify-content: center !important;
        }
      }
    }

    //内容数据
    // .tcon {
    // }
    .tNullData {
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      color: #bbbec7;
    }
  }
}

.el-checkbox {
  transform: scale(1.5);
}

.footer {
  text-align: right;
  margin-top: 24px;

  >* {
    margin-left: 24px;

    &:first-child {
      margin-left: 0;
    }
  }
}

.yellowFont {
  color: #f9f871;
}

.redFont {
  color: #fa5058;
}
</style>